(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/coupon-choice-button/assets/javascripts/coupon-choice-button.js') >= 0) return;  svs.modules.push('/components/tipsen/coupon-choice-button/assets/javascripts/coupon-choice-button.js');
"use strict";

const _svs$ui = svs.ui,
  ReactButton = _svs$ui.ReactButton,
  ReactIcon = _svs$ui.ReactIcon;
const clx = svs.components.lbUtils.clx;
const analytics = svs.components.analytics;
const _svs$components$lbUti = svs.components.lbUtils.useMediaQuery,
  useMediaQuery = _svs$components$lbUti.useMediaQuery,
  breakpoints = _svs$components$lbUti.breakpoints,
  BREAKPOINT_AM = _svs$components$lbUti.BREAKPOINT_AM;
const useBranding = svs.components.tipsen.hooks.useBranding;
const useCurrentDraw = svs.components.tipsen.drawProvider.hooks.useCurrentDraw;
const getProductBrandByDraw = svs.components.lbUtils.brandMapping.fn.getProductBrandByDraw;
const CouponChoiceButton = _ref => {
  let ariaControls = _ref.ariaControls,
    isAriaExpanded = _ref.isAriaExpanded,
    ariaLabel = _ref.ariaLabel,
    children = _ref.children,
    className = _ref.className,
    dataTestId = _ref['data-testid'],
    _ref$hasClickAnalytic = _ref.hasClickAnalytics,
    hasClickAnalytics = _ref$hasClickAnalytic === void 0 ? true : _ref$hasClickAnalytic,
    icon = _ref.icon,
    isDisabled = _ref.isDisabled,
    isSelected = _ref.isSelected,
    onClick = _ref.onClick;
  const isSmall = useMediaQuery(breakpoints.down(BREAKPOINT_AM));
  const buttonAndIconSize = isSmall ? 200 : 300;
  const draw = useCurrentDraw();
  const brandingList = useBranding();
  const brandingByDraw = getProductBrandByDraw(draw);
  const branding = brandingByDraw || brandingList[brandingList.length - 1] || brandingList[0] || 'sport';
  const blockName = 'btn-coupon-choice';
  const classNames = clx(blockName, className, {
    ["".concat(blockName, "-selected")]: isSelected,
    ["".concat(blockName, "-disabled")]: isDisabled,
    ["".concat(blockName, "-branding-").concat(branding)]: branding
  });
  const trackEventOnCouponChoiceButton = () => {
    analytics.trackEvent({
      category: "Nya tipsen",
      action: children,
      opt_label: location.pathname
    });
  };
  return React.createElement(ReactButton, {
    "aria-controls": ariaControls,
    "aria-expanded": isAriaExpanded,
    "aria-label": ariaLabel,
    className: classNames,
    "data-testid": dataTestId,
    disabled: isDisabled,
    "icon-position": "left",
    onClick: e => {
      if (hasClickAnalytics) {
        trackEventOnCouponChoiceButton();
      }
      onClick && onClick(e);
    },
    size: buttonAndIconSize,
    title: ariaLabel
  }, icon && React.createElement(ReactIcon, {
    icon: icon,
    size: buttonAndIconSize
  }), children && React.createElement("span", {
    className: "".concat(icon ? 'btn-text' : '')
  }, children));
};
setGlobal('svs.components.tipsen.couponChoiceButton.CouponChoiceButton', CouponChoiceButton);

 })(window);